import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/baseGoods/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/baseGoods/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 导出模板
export function exportDoc (params) {
  return request.get('/business/baseGoods/export', params, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/baseGoods/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/baseGoods/update', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/baseGoods/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/baseGoods/delete/batch', {
    params: {
      ids
    }
  })
}

// 修改状态
export function updateStatus (data) {
  return request.post('/business/baseGoods/updateStatus', data)
}
/*export function updateStatusById (data) {
  return request.post('/business/baseGoods/updateStatusById', data)
}*/

// 列表 - 商品选择
export function findListForbaseGoodsId (goodsId) {
  return request.get(`/business/category/findListForGoodsId?goodsId=${goodsId}`)
}

// 根据ID查询
export function queryById (id) {
  return request.get(`/business/baseGoods/${id}`)
}